// calculator specific functions for price calculator Smidtje Canal Cruises (Haarlem)

const vmr = 2.6, // € per person
    price_sloop = 250, // € per hour
    price_tour_boat = 350, // € per hour
    price_tour_boat_large = 395, // € per hour
    price_bitterballs = 4.5, // € per person
    price_sandwich_lunch = 17.5, // € per person
    price_cheese_wine = 21.5, // € per person
    price_high_tea = 21.75, // € per person
    price_buffet = 31.5, // € per person
    price_3_course = 63, // € per person
    price_drinks_unlimited = 12.5, // € per person per hour
    price_extra_host = 45, // € per hour
    price_extra_chef = 60; // € per hour

function formatNumber(number, decimals = 2) {
    number = parseFloat(number).toFixed(decimals);

    let  str = number + '',
        x = str.split('.'),
        x1 = x[0],
        x2 = x.length > 1 ? ',' + x[1] : '',
        rgx = /(\d+)(\d{3})/;

    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + '.' + '$2');
    }

    return x1 + x2;
}

$('.calculator.calculator--price-scc').each(function () {
    let $calculator = $(this);

    // add specific init functions here
}).on('runCalculation', function () {
    let $calculator = $(this);

    if (!$calculator.hasClass('calculator')) return false;

    let person_count = $calculator.find('input[name="persons"]').val(),
        catering = $calculator.find('input[name="catering"]:checked').val(),
        boat_type = $calculator.find('input[name="boat"]:checked').val(),
        duration = $calculator.find('input[name="duration"]').val(),
        drinks = $calculator.find('input[name="drinks"]:checked').val();

    if ($calculator.find('input[name="catering"]').is('input[type="checkbox"]')) {
        catering = $calculator.find('input[name="catering"]:checked').map(function () { return $(this).val() }).get();
    }

    // trigger GTM on calculation start
    $calculator.on('click', 'input', function () {
        let calculation_started = $calculator.attr('data-calculation-started'),
            calculation_completed = $calculator.attr('data-calculation-completed');

        if (typeof calculation_started === 'undefined' || calculation_started === 'false') {
            $calculator.attr('data-calculation-started', '');

            let event_label = 'Prijscalculatie gestart',
                page_url = $(location).attr('href');

            const event = {
                'event': 'gtm_event',
                'event_label': event_label,
                'event_url': page_url
            }

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push(event);
            }
        }

        if (typeof calculation_completed === 'undefined') {
            if ($(this).closest('.question').is(':last-child')) {
                $calculator.attr('data-calculation-completed', '');

                let event_label = 'Prijscalculatie voltooid',
                    page_url = $(location).attr('href');

                const event = {
                    'event': 'gtm_event',
                    'event_label': event_label,
                    'event_url': page_url
                }

                if (typeof dataLayer !== 'undefined') {
                    dataLayer.push(event);
                }
            }
        }
    });

    // update duration range input when 3-course dinner is selected
    if (catering) {
        let $input_duration = $calculator.find('input[name="duration"]'),
            newValue;

        if ('3-course' === catering) {
            newValue = 3;
        } else {
            newValue = 1.5;
        }

        if ($input_duration.attr('min') !== newValue.toString()) {
            $input_duration.attr('min', newValue);

            if (duration < newValue) {
                duration = newValue;
                $input_duration.attr('value', duration);
            }

            let modified = $input_duration.attr('data-range-modified');

            if (typeof modified === 'undefined') {
                $input_duration.attr('data-range-dont-modify', '');
            }

            $input_duration.attr('data-range-update-labels', '');
            $input_duration.trigger('input');
        }
    }

    if (!person_count || !catering || !boat_type || !duration || !drinks) {
        // console.info('Not enough data for calculation');

        // reset values on frontend
        $calculator.find('[data-calculator-value="cost_boat"]').text(formatNumber(0)).trigger('valueUpdate');
        $calculator.find('[data-calculator-value="cost_catering"]').text(formatNumber(0)).trigger('valueUpdate');
        $calculator.find('[data-calculator-value="cost_drinks"]').text(formatNumber(0)).trigger('valueUpdate');
        $calculator.find('[data-calculator-value="cost_extra_staff"]').text(formatNumber(0)).trigger('valueUpdate');
        $calculator.find('[data-calculator-value="cost_vmr"]').text(formatNumber(0)).trigger('valueUpdate');
        $calculator.find('[data-calculator-value="cost_total"]').text(formatNumber(0)).trigger('valueUpdate');

        // hide form and scroll-to button
        $calculator.find('.calculator__form').stop().slideUp(150);
        $calculator.find('.calculator__scroll-to-form').closest('.column').stop().fadeOut(150);

        return false;
    }

    let cost_total = 0,
        cost_boat = 0,
        cost_catering = 0,
        cost_drinks = 0,
        cost_extra_staff = 0,
        cost_vmr = 0;

    // calculate boat cost
    if ('sloop' === boat_type) {
        cost_boat += duration * price_sloop;
    } else if ('tour-boat' === boat_type) {
        cost_boat += duration * price_tour_boat;
    } else if ('tour-boat-large' === boat_type) {
        cost_boat += duration * price_tour_boat_large;
    }

    // calculate catering cost
    if ('bitterballs' === catering) {
        cost_catering += person_count * price_bitterballs;
    } else if ('cheese-wine' === catering) {
        cost_catering += person_count * price_cheese_wine;
    } else if ('high-tea' === catering) {
        cost_catering += person_count * price_high_tea;
    } else if ('sandwich-lunch' === catering) {
        cost_catering += person_count * price_sandwich_lunch;
    } else if ('buffet' === catering) {
        cost_catering += person_count * price_buffet;
    } else if ('3-course' === catering) {
        cost_catering += person_count * price_3_course;
    }

    // calculate drinks cost
    if ('unlimited' === drinks) {
        cost_drinks += (person_count * price_drinks_unlimited) * duration;
    }

    // calculate extra staff cost
    if (person_count >= 20) {
        if ('3-course' === catering) {
            cost_extra_staff += price_extra_host;
        }
    }

    // calculate VMR
    cost_vmr += person_count * vmr;

    cost_total += cost_boat + cost_catering + cost_drinks + cost_extra_staff + cost_vmr;

    // insert values into calculator frontend
    $calculator.find('[data-calculator-value="cost_boat"]').text(formatNumber(cost_boat)).trigger('valueUpdate');
    $calculator.find('[data-calculator-value="cost_catering"]').text(formatNumber(cost_catering)).trigger('valueUpdate');
    $calculator.find('[data-calculator-value="cost_drinks"]').text(formatNumber(cost_drinks)).trigger('valueUpdate');
    $calculator.find('[data-calculator-value="cost_extra_staff"]').text(formatNumber(cost_extra_staff)).trigger('valueUpdate');
    $calculator.find('[data-calculator-value="cost_vmr"]').text(formatNumber(cost_vmr)).trigger('valueUpdate');
    $calculator.find('[data-calculator-value="cost_total"]').text(formatNumber(cost_total)).trigger('valueUpdate');

    // show form and scroll-to button
    $calculator.find('.calculator__form').stop().slideDown(150);
    $calculator.find('.calculator__scroll-to-form').closest('.column').stop().fadeIn(150);
});
